import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NotificationAlert from "react-notification-alert";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import TextField from '@material-ui/core/TextField';
// import Button from '@material-ui/core/Button';
import { Button, Checkbox } from '@material-ui/core';
import Axios from 'axios';
import { API_CONFIG } from "../../../config/config.jsx";
import OperatingHours from "../OperatingHours/OperatingHours.jsx"
import Secure from '../../../components/Secure.jsx';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AsyncSelect from 'react-select/async';


const styles = theme => ({
  textField: {
    width: "200px"
  }
});

class StoreOnBoardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
     // password: 'rudreshrd',
      mobileNo: '',
      address: '',
      deviceId:'',
      email:'',
      vehicleNumber:'',
      payoutBankDetails:'',
      refferedBy: sessionStorage.getItem("plugoUserMobileNo"),
      // city: '',
      // floor: '',
      // pincode: '',
      // state: '',
      // latitude: '',
      // longitude: '',
      // business: '',
      // website: '',
     // isVisible: false,
      //isReviewApplicable: false,
     // isEnableMobileNumber: false,
      // storeId: '',
      // timing: [],
      // showTime: false,
      // errorText: '',
      // timingText: '',
      // isButtonDisabled: false,
       BUIDList:[],
      // searchText:'',
      BUID:''
    };
    this.autocompleteInput = React.createRef();
    this.autocomplete = null;
   // this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
  }

  componentDidMount() {
    this.getBUID()
    const mobileNo = sessionStorage.getItem('plugoUserMobileNo');
    // if (process.env.REACT_APP_ACTIVE_REGION == "europe") {
    //   // if (mobileNo.startsWith('+31')) {
    //   //   this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.current,
    //   //     {
    //   //       componentRestrictions: { country: 'NL' },
    //   //       // types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
    //   //     });
    //   // }
    //   // else {
    //     this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.current,
    //       {
    //         componentRestrictions: { country: ['de', 'ch', 'nl'] },
    //         // types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
    //       });
    // //   }
    //  }
    // else {

    //   this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.current,
    //     {
    //       componentRestrictions: { country: 'IN' },
    //       // types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
    //     });
    // }

   // this.autocomplete.addListener('place_changed', this.handlePlaceChanged);
  }
getBUID =()=>{
  const token = sessionStorage.getItem("plugoAuthKey");
  const userId = sessionStorage.getItem("plugoUserId");
  Axios.get(`${API_CONFIG.HOST}/user/buid`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-USER-ID": userId,
    },
  })
    .then((res) => {
      console.log(res);
      this.setState({
        BUIDList: res.data.map(data =>({value:data,label:data})),
      });
    })
    .catch((error) => {
      this.setState({
        BUIDList:[],
      }); 
    });
}
  // parseTime(time) {
  //   if (parseInt(time) < 1200) {
  //     const d = new Date(70, 1, 1, parseInt(time.substr(0, 2)), time.substr(2), 0);
  //     return d
  //   } else {
  //     const d = new Date(70, 1, 1, parseInt(time.substr(0, 2)), time.substr(2), 0);
  //     return d;
  //   }
  // }

  // handlePlaceChanged() {
  //   const event = this.autocomplete.getPlace();
  //   console.log(event);
  //   this.setState({
  //     name: event['name'],
  //     address: event['formatted_address'],
  //     latitude: event['geometry']['location'].lat(),
  //     longitude: event['geometry']['location'].lng(),
  //   })

  //   if (process.env.REACT_APP_ACTIVE_REGION == "europe")       // This is for Europe build
  //   {

  //     event['address_components'].forEach((component) => {
  //       if (component['types'].includes('locality')) {
  //         this.setState({
  //           city: component['long_name']
  //         })
  //       }
  //       if (component['types'].includes('administrative_area_level_1')) {
  //         this.setState({
  //           state: component['long_name']
  //         })
  //       }
  //       if (component['types'].includes('postal_code')) {
  //         this.setState({
  //           pincode: component['long_name']
  //         })
  //       }

  //     });

  //   }
  //   else                                    // This is for INDIA build
  //   {
  //     event['address_components'].forEach((component) => {
  //       if (component['types'].includes('postal_code')) {
  //         this.setState({
  //           pincode: component['long_name']
  //         })
  //       }
  //     });

  //     Axios.get(`https://api.postalpincode.in/pincode/${this.state.pincode}`)
  //       .then(res => {
  //         this.setState({
  //           floor: 'Ground Floor',
  //           city: res.data[0]['PostOffice'][0]['District'],
  //           state: res.data[0]['PostOffice'][0]['State'],
  //           business: 'Restaurant',
  //           password: 'rudreshrd',
  //         });
  //       });
  //   }


  //   if (event['opening_hours']) {
  //     let timings = event['opening_hours']['periods'];
  //     console.log("timiing: ", timings);
  //     let newTimings = [];
  //     timings.forEach(timing => {
  //       if (timing['open'] && timing['close']) {
  //         let time1 = {};
  //         let time2 = {};
  //         if (timing['open']['day'] === timing['close']['day']) {
  //           time1['day'] = timing['open']['day'];
  //           time1['startTime'] = this.parseTime(timing['open']['time']);
  //           time1['endTime'] = this.parseTime(timing['close']['time']);
  //           newTimings.push(time1);
  //         } else {
  //           time1['day'] = timing['open']['day'];
  //           time1['startTime'] = this.parseTime(timing['open']['time']);
  //           time1['endTime'] = this.parseTime('2359');
  //           newTimings.push(time1);
  //           time2['day'] = timing['close']['day'];
  //           time2['startTime'] = this.parseTime('0000');
  //           time2['endTime'] = this.parseTime(timing['close']['time']);
  //           newTimings.push(time2);
  //         }
  //       }
  //     });
  //     this.setState({
  //       timing: newTimings
  //     })
  //   } else {
  //     this.setState({ timingText: 'Please Add Operating Hours.', })
  //     console.log('No Timing Details found')
  //   }

  // }


  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  change = (event) => {
    this.setState({
      mobileNo: event.target.value,
      isEnableMobileNumber: true,
    });
  }
  // onChangeVisible = () => {
  //   this.setState({
  //     isVisible: !this.state.isVisible
  //   })
  // }
  // onChangeReviewApplicable = () => {
  //   this.setState({
  //     isReviewApplicable: !this.state.isReviewApplicable
  //   })
  // }
  onChangeSearchText = (inputValue) => {
    this.setState({
        searchText: inputValue
    })
};
  BUIDHandleChange = (event) => {
  this.setState({
    BUID:event.value
  });}
  userLoadOptions = (inputValue) => {
    return new Promise((resolve) => {
      let requiredArray = [];
      requiredArray= this.state.BUIDList.filter(i =>i.label.toLowerCase().includes(inputValue.toLowerCase()));
      resolve( requiredArray.length ? requiredArray :[])})
  
};
  submit = event => {
    event.preventDefault();
    const mobileNo = sessionStorage.getItem('plugoUserMobileNo');
    const userId = sessionStorage.getItem("plugoUserId");
    // if (window.isHyd && (this.state.city !== "Hyderabad" && this.state.city !== '')) {
    //   this.setState({ errorText: "Only Hyderabad is allowed" });
    //   return;
    // }
    this.setState({
      isButtonDisabled: true
    });
    // let countryCode = mobileNo.startsWith('+31') ? 'NL' : 'DE'
    // if (mobileNo.startsWith('+91')) {
    //   countryCode = 'IN'
    // }
    const createStoreData = {
     //id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
     deviceId:this.state.deviceId,
      mobile: this.state.mobileNo,
      name: this.state.name,
      //password: this.state.password,
      address: this.state.address,
      email:this.state.email,
      vehicleNumber: this.state.vehicleNumber,
      payoutBankDetails:this.state.payoutBankDetails,
      refferedBy: mobileNo,
      //city: this.state.city,
      //floor: this.state.floor,
     // pincode: this.state.pincode,
     // state: this.state.state,
     // countryCode: countryCode,
     // lat: this.state.latitude,
     // lng: this.state.longitude,
     // business: this.state.business,
     // website: this.state.website,
      // enableMobileNumber: this.state.isEnableMobileNumber,
      // isVisible: this.state.isVisible,
      // reviewApplicable: this.state.isReviewApplicable,
      ownerBuid:  this.state.BUID
    }
    const token = sessionStorage.getItem('plugoAuthKey');
    console.log('token', token);
  //  const userId = sessionStorage.getItem('plugoUserId');
    Axios.post(`${API_CONFIG.HOST}/cable-store/create`, createStoreData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "X-USER-ID": userId
      }
    })
      .then(res => {
        console.log('create store res',res);
        // this.setState({
        //   isVisible: false,
        //   isReviewApplicable: false,
        //   isEnableMobileNumber: false,
        //   storeId: res.data.id,
        //   showTime: true
        // })
        var options = {
          place: 'tc',
          message: " " + "Created Successfully",
          type: 'success',
          icon: 'far fa-check-circle',
          autoDismiss: 4
        }
        if (this.notification && this.notification.state.notifyTR.length < 1) {
          this.notification.notificationAlert(options)
        }
      })
      .catch(error => {
        console.log('create store error', error);
        this.setState({ loading: false })
        const options = {
          place: 'tc',
          message: `  ${error.response ? error.response.data.message : 'Something went wrong'}`,
          type: 'danger',
          icon: 'fas fa-exclamation-triangle',
          autoDismiss: 4
        }
        if (this.notification && this.notification.state.notifyTR.length < 1) {
          this.notification.notificationAlert(options)
        }
      })

  };
  render() {
    const { classes } = this.props;

    return (
      <div>
        <div className="rna-container">
          <NotificationAlert ref={(c) => { this.notification = c }} />
        </div>
        <Card>
          {/* <div style={{ width: "80%", border: "1px #A9A9A9 solid", height: "35px", paddingLeft: "8px" }}>
            <i class="fa fa-search" aria-hidden="true"></i>
            <input ref={this.autocompleteInput} id="autocomplete" style={{ width: "97%", border: "none", marginTop: "4px", marginLeft: "4px" }} placeholder="Search Store for autocomplete..."
              type="text">
            </input>
          </div> */}
          <CardBody>
            <form className={classes.container} onSubmit={this.submit}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    required
                    id="outlined-name"
                    label="Name"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.name}
                    onChange={this.handleChange('name')}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    required
                    id="outlined-name"
                    label="Device Id"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.deviceId}
                    onChange={this.handleChange('deviceId')}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                  required
                    id="outlined-mobileNo"
                    label="Mobile No"
                    value={this.state.mobileNo}
                    onChange={this.handleChange('mobileNo')}
                    className={classes.textField}
                    margin="normal"
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    required
                    id="outlined-address"
                    label="Address"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.address}
                    onChange={this.handleChange('address')}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                   // required
                    id="outlined-city"
                    label="Email"
                    value={this.state.email}
                    onChange={this.handleChange('email')}
                    className={classes.textField}
                    margin="normal"
                    //error={this.state.errorText.length === 0 ? false : true}
                   // helperText={this.state.errorText}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    required
                    id="outlined-floor"
                    label="Vehicle Number"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.vehicleNumber}
                    onChange={this.handleChange('vehicleNumber')}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    required
                    id="outlined-pincode"
                    label="Payout Bank Details"
                    value={this.state.payoutBankDetails}
                    onChange={this.handleChange('payoutBankDetails')}
                    className={classes.textField}
                    margin="normal"
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    required
                    id="outlined-state"
                    label="Reffered By"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.refferedBy}
                   // onChange={this.handleChange('refferedBy')}
                  />
                </GridItem>
              </GridContainer>
                       <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
              <div style={{marginTop:'7px'}}>
              <AsyncSelect
                            cacheOptions
                            loadOptions={this.userLoadOptions}
                            onChange={this.BUIDHandleChange}
                            defaultOptions={this.state.BUIDList}
                            placeholder="BUID"
                            
                            className={classes.textField}
                            onInputChange={this.onChangeSearchText}
                        />
                </div>
                </GridItem>
                </GridContainer>
              {/* <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <div style={{ marginTop: "15px" }}>
                  <Checkbox
                    checked={this.state.isVisible}
                    value={this.state.isVisible}
                    style={{ color: "#3f51b5" }}
                    onChange={() => this.setState({ isVisible: !this.state.isVisible })}
                  />
                <label style={{ fontSize: "17px" }}>Show Store On Map</label>

                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div style={{ marginTop: "15px" }}>
                    <Checkbox
                      checked={this.state.isReviewApplicable}
                      value={this.state.isReviewApplicable}
                      onChange={this.onChangeReviewApplicable}
                      classes={{
                        root: classes.root,
                        checked: classes.checked,
                      }}
                      style={{ color: "#3f51b5" }}
                    />
                    <label style={{ fontSize: "17px" }}>Review Applicable</label>
                  </div>
                </GridItem>
              </GridContainer> */}
              <div style={{ marginTop: "20px", marginLeft: "10px" }}>
                <Button type="submit" disabled={this.state.isButtonDisabled} variant="contained" color="primary">
                  Create
                </Button>
              </div>
            </form>
          </CardBody>
        </Card>
        {/* {this.state.showTime ?
          Secure("CREATE_USERS", <OperatingHours storeId={this.state.storeId} operatingHours={this.state.timing} timingText={this.state.timingText} />)
          : ''} */}
      </div>
    );
  }
}

StoreOnBoardForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StoreOnBoardForm);
